import { setAuthProvider } from '@repo/api/auth-provider'
import { createClerkAuthProvider } from '@repo/api/auth-providers'
import { useClerk } from '@clerk/nextjs'
import { useEffect } from 'react'

/**
 * Initialize the @/repo/api auth provider with Clerk
 * This should be called during app initialization
 */
export function initializeAuthProvider(clerkInstance?: any) {
  const clerkProvider = createClerkAuthProvider({
    clerk: clerkInstance,
    tokenTemplate: process.env.NEXT_PUBLIC_CLERK_JWT_TEMPLATE,
  })

  setAuthProvider(clerkProvider)
}

/**
 * Hook to set up @/repo/api auth provider with current Clerk instance
 */
export function useAuthProviderSetup() {
  const clerk = useClerk()

  useEffect(() => {
    if (clerk) initializeAuthProvider(clerk)
  }, [clerk])
}

/**
 * Manual setup function for cases where you have direct access to Clerk instance
 */
export function setupClerkAuth(clerkInstance: any) {
  initializeAuthProvider(clerkInstance)
}
